<p-confirmDialog></p-confirmDialog>

<div class="flex align-items-center gap-2">
    <!-- Display users who are currently modifying the document -->
    <div *ngIf="lockState.isLocked">
        <p-avatarGroup [pTooltip]="getModifyingUsersTooltip()">
            <p-avatar *ngFor="let user of lockState.modifyingUsers.slice(0, 2)" 
                      [label]="getInitials(user)" 
                      [style]="{'background-color': getFullName(user) | colorFromString}" 
                      shape="circle"
                      size="large" >
            </p-avatar>
            <p-avatar *ngIf="lockState.modifyingUsers.length > 2" 
                      [label]="'+' + (lockState.modifyingUsers.length - 2)" 
                      shape="circle" 
                      size="large">
            </p-avatar>
        </p-avatarGroup>
    </div>

    <!-- Buttons -->
    <ng-container *ngIf="!isModifying; else modifyingButtons">
        <p-button (click)="modify()" 
                  icon="pi pi-pencil" 
                  label="Modifier"
                  styleClass="p-button-primary modify-button"></p-button>
    </ng-container>

    <ng-template #modifyingButtons>
        <p-button (click)="save()" icon="pi pi-check" styleClass="p-button-success mr-2"></p-button>
        <p-button (click)="cancel($event)" icon="pi pi-times" styleClass="p-button-secondary"></p-button>
    </ng-template>
</div> 